import React from "react";
import "./Redirect_btn.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const Redirect_btn = ({ name, link, hideIcon = false }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(link);
  };

  return (
    <div className="redirect_btn_div">
      <button className="redirect_btn btn" onClick={handleClick}>
        {name}
        {!hideIcon && (
          <span>
            <FontAwesomeIcon icon={faArrowRight} />
          </span>
        )}
      </button>
    </div>
  );
};

export default Redirect_btn;
